import { useApiClient } from './apiClient';

export const useApi = () => {
  const apiClient = useApiClient();

  const api = {
    getCategories: async () => {
      const response = await apiClient.get('/api/categories');
      if (response.ok) {
        return await response.json();
      }
      throw new Error('Failed to fetch categories');
    },

    getHealth: async () => {
      const response = await apiClient.get('/api/health');
      if (response.ok) {
        return await response.json();
      }
      throw new Error('Failed to get health status');
    },

    analyzeFiles: async (formData: FormData) => {
      const response = await apiClient.post('/api/analyze', formData);
      if (response.ok) {
        return await response.json();
      }
      throw new Error('Analysis failed');
    },

    queryTranscript: async (data: { messages: { role: string; content: string }[]; transcript: string; category: string }) => {
      const response = await apiClient.post('/api/query-transcript', data);
      if (response.ok) {
        return await response.json();
      }
      throw new Error('Query failed');
    },
  };
  return api;
};
